var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrimaryLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.498 20.5-.996-4.98a.498.498 0 0 0-.488-.4h-.996a.498.498 0 0 0-.489.4l-.996 4.98a.498.498 0 1 0 .977.196l.318-1.592h1.375l.318 1.592a.498.498 0 1 0 .977-.196zm-2.47-2.392.398-1.992h.18l.398 1.992h-.977zM26.477 19.104h-1.495v-.498a.498.498 0 0 0-.996 0v.498h-1.494a.498.498 0 0 0 0 .996h.12a6.23 6.23 0 0 0 1.182 2.184c-.383.35-.77.638-1.115.913a.498.498 0 1 0 .622.778c.347-.277.763-.586 1.183-.971.421.386.838.695 1.183.971a.498.498 0 1 0 .623-.778c-.344-.275-.732-.562-1.115-.913a6.23 6.23 0 0 0 1.181-2.184h.12a.498.498 0 0 0 0-.996zm-1.993 2.448a5.247 5.247 0 0 1-.82-1.455h1.64a5.246 5.246 0 0 1-.82 1.455z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.506 14.621H20.32l-.214-1.712a1.496 1.496 0 0 0-1.482-1.309h-5.13c-.825 0-1.495.67-1.495 1.494v10.99c0 .824.67 1.495 1.494 1.495h4.2l.21 1.712c.094.745.731 1.309 1.483 1.309h8.119c.824 0 1.494-.67 1.494-1.494v-10.99c0-.824-.67-1.495-1.494-1.495zm-14.012 9.961a.499.499 0 0 1-.498-.498v-10.99c0-.274.224-.498.498-.498h5.13c.251 0 .464.188.495.436l1.44 11.55h-7.065zm5.37 2.35-.167-1.353h1.337l-1.17 1.353zm9.14.174a.499.499 0 0 1-.498.498h-7.907l1.896-2.193a.497.497 0 0 0 .12-.4l-1.17-9.393h7.06c.275 0 .499.223.499.498v10.99z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryLanguage);
export default __webpack_public_path__ + "static/media/primary-language.2c7304b09aa83281b07ffa8c62f3c317.svg";
export { ForwardRef as ReactComponent };